import App from "./App";
import "./index.css";

import {
  AppConfig,
  RemoteDefinition,
  Shell,
  getRemoteAppConfig,
  renderRoot,
} from "@sgi/af-shell-shared";

export async function renderApp() {
  const config: AppConfig = await getRemoteAppConfig(
    `${__webpack_public_path__}${"config.json"}`
  );
  (window as any)["runConfig"] = config;

  let remotes: RemoteDefinition[] = [];

  if (config.REACT_APP_ENV === "prd") {
    await import("./Remotes.prd").then((remotesComponent) => {
      remotes = remotesComponent.Remotes;
    });
  } else if (config.REACT_APP_ENV === "par") {
    await import("./Remotes.par").then((remotesComponent) => {
      remotes = remotesComponent.Remotes;
    });
  } else if (config.REACT_APP_ENV === "int") {
    await import("./Remotes.int").then((remotesComponent) => {
      remotes = remotesComponent.Remotes;
    });
  } else {
    await import("./Remotes.dev").then((remotesComponent) => {
      remotes = remotesComponent.Remotes;
    });
  }
  if (window.location.host === "brokershell.sgicloud.ca" || window.location.host === 'broker.mysgi.ca') {
    remotes = remotes.concat(getProdClaimsRemotes());
  } else if (window.location.hostname.includes('parallel')) {
    remotes = remotes.concat(getParallelClaimsRemotes());
  }
  else {
    remotes = remotes.concat(getNonProdClaimsRemotes(getEnvironmentKey()));
  }

  await renderRoot({ children: <App />, remotes, shell: Shell.Business });
}

function getEnvironmentKey() {
  let searchParams = new URLSearchParams(window.location.search);
  let toReturn: string | null = null;

  searchParams.forEach((value, key) => {
    if (key === "env") toReturn = value;
  });

  return toReturn;
}
function getNonProdClaimsRemotes(env: string | null) {
  let claimsRemotes: RemoteDefinition[] = [];
  let claimsUrl: string = "";

  switch (env) {
    case "dv1":
      claimsUrl = "https://dv1.claims.wb.sgicloud.ca/";
      break;
    case "dv2":
      claimsUrl = "https://dv2.claims.wb.sgicloud.ca/";
      break;
    case "qa1":
      claimsUrl = "https://qa1.claims.wb.sgicloud.ca/";
      break;
    case "qa2":
      claimsUrl = "https://qa2.claims.wb.sgicloud.ca/";
      break;
    case "bat":
      claimsUrl = "https://bat.claims.wb.sgicloud.ca/";
      break;
    case "pat":
      claimsUrl = "https://pat.claims.wb.sgicloud.ca/";
      break;
    case 'b15':
      claimsUrl = 'https://b15.claims.wb.sgicloud.ca/';
      break;
    default:
      claimsUrl = "https://bat.claims.wb.sgicloud.ca/";
      break;
  }

  claimsRemotes.push({
    url: claimsUrl,
    name: "claims",
    modules: ["register"],
  });

  return claimsRemotes;
}

function getParallelClaimsRemotes() {
  let claimsRemotes: RemoteDefinition[] = [];

  claimsRemotes.push({
    url: "https://pat.claims.wb.sgicloud.ca/",
    name: "claims",
    modules: ["register"],
  });

  return claimsRemotes;
}


function getProdClaimsRemotes() {
  let claimsRemotes: RemoteDefinition[] = [];

  claimsRemotes.push({
    url: "https://claims.wb.sgicloud.ca/",
    name: "claims",
    modules: ["register"],
  });

  return claimsRemotes;
}
